import { render, staticRenderFns } from "./ProjectStaffAddOrUpdate.vue?vue&type=template&id=2d016928&scoped=true&"
import script from "./ProjectStaffAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectStaffAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d016928",
  null
  
)

export default component.exports